import { useQuery } from '@tanstack/react-query';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';
import { createHttpHeader } from '@/utils/network/createHTTPHeaders';
import { decryptTreezorResponse } from '@/services/encryption/decryptTreezorResponse';
import { IWallet } from '@/features/wallets/store/models/wallet.model';
import { useConfigWalletIdsList } from '@/features/wallets/hooks/useConfigWalletIdsList';

type TUserWalletInfoProps = {
  userId?: number;
};

export function useUserWalletInfo({ userId }: TUserWalletInfoProps) {
  const headers = createHttpHeader();
  const config = useDashboardConfig();
  const walletTypeIdList = useConfigWalletIdsList();

  const {
    data: userWalletData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['getUserWalletInfo', userId],
    queryFn: async () => {
      const params = new URLSearchParams();
      params.set('userId', userId.toString());
      walletTypeIdList.forEach((typeId) => {
        params.append('walletTypeIdList[]', typeId.toString());
      });
      const response = await fetch(`${config.api.baseUrl}/v1/wallets?${params.toString()}`, {
        headers,
      });
      return await decryptTreezorResponse<IWallet>(response, { isSequential: true });
    },
    enabled: !!userId,
    staleTime: 120000,
  });

  return { isLoading, userWalletData, isError };
}
